// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__AtODR","label":"Completed_label__2vXVH"};